module.exports = __webpack_public_path__ + "static/media/uam.227c3a7b.png";